import React from 'react';
import styled from 'styled-components';

interface DashboardCardProps {
  title: string;
  onClick?: () => void;
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  onClick,
  leftContent,
  rightContent,
}) => (
  <Card onClick={onClick}>
    <ContentContainer>
      <LeftColumn>
        <CardTitle>{title}</CardTitle>
        {leftContent}
      </LeftColumn>
      <RightColumn>{rightContent}</RightColumn>
    </ContentContainer>
  </Card>
);

export default DashboardCard;

// Styled Components
const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5px;
  border-radius: 6px;
  overflow: hidden;
`;

const CardTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 6px;
`;

const ContentContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const RightColumn = styled.div`
  flex: 4;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
`;
